import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CareersPage from "./pages/CareersPage";
import PressPage from "./pages/PressPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import TemplatesPage from "./pages/TemplatesPage";
import DocsPage from "./pages/DocsPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import SecurityPage from "./pages/SecurityPage";
import CookiesPage from "./pages/CookiesPage";
import DataDeletionPage from "./pages/DataDeletionPage";
import VoiceAIPage from "./pages/VoiceAIPage";
import PhonePage from "./pages/PhonePage";
import ContactCenterPage from "./pages/ContactCenterPage";
import CRMPage from "./pages/CRMPage";
import PersonalAssistantPage from "./pages/PersonalAssistantPage";
import ECommercePage from "./pages/ECommercePage";
import ChatBotPage from "./pages/ChatBotPage";
import EnterpriseAssistantPage from "./pages/EnterpriseAssistantPage";
import BlogPostPage from "./pages/BlogPostPage";
import PricingPage from "./pages/PricingPage";
import ReferencesPage from "./pages/ReferencesPage";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import BackgroundSparkles from "./components/BackgroundSparkles";
import ChatWidgetButton from "./components/ChatWidgetButton";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className="App">
          <BackgroundSparkles />
          <div style={{ position: "relative", zIndex: 1 }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/references" element={<ReferencesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/press" element={<PressPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/help" element={<HelpCenterPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/data-deletion" element={<DataDeletionPage />} />
              <Route path="/product/voice-ai" element={<VoiceAIPage />} />
              <Route path="/product/phone" element={<PhonePage />} />
              <Route path="/product/contact-center" element={<ContactCenterPage />} />
              <Route path="/product/crm" element={<CRMPage />} />
              <Route path="/product/personal-assistant" element={<PersonalAssistantPage />} />
              <Route path="/product/ecommerce" element={<ECommercePage />} />
              <Route path="/product/chatbot" element={<ChatBotPage />} />
              <Route path="/product/enterprise-assistant" element={<EnterpriseAssistantPage />} />
              <Route path="/pricing" element={<PricingPage />} />
            </Routes>
          </BrowserRouter>
          <ChatWidgetButton />
          </div>
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
